import { render } from "./user-current.vue?vue&type=template&id=3ee027da&scoped=true&ts=true"
import script from "./user-current.vue?vue&type=script&lang=ts"
export * from "./user-current.vue?vue&type=script&lang=ts"

import "./user-current.vue?vue&type=style&index=0&id=3ee027da&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee027da"]])

export default __exports__